import React, { useContext, useEffect, useState } from 'react';
import AdminMasterLayout from '../../../layout/admin/AdminMasterLayout';
import "../../../assets/css/admin/FAQsInAdmin/FAQsInAdmin.css";
import { Container, Spinner, Button } from "react-bootstrap";
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import Swal from 'sweetalert2';

const FAQsInAdmin = () => {
  const { baseUrl, regTpChecker } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [btnLabel, setBtnLabel] = useState("Save");
  const [idToUpdateDeletefaqs, setIdToUpdateDeletefaqs] = useState("");
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [selectedType, setSelectedType] = useState("Customer");
  const [showSuccess, setShowSuccess] = useState(false);
  const [editId, setEditId] = useState(null);
  const [faqs, setfaqs] = useState([]);
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [loadingEditId, setLoadingEditId] = useState(null);
  const [loadingDeleteId, setLoadingDeleteId] = useState(null);

  const [FAQs, setFAQs] = useState([]);
  const uploadfaqs =() => {
    console.log(question,answer,selectedType)
    const formData = new FormData();
     formData.append("question", question);
    formData.append("answer", answer);
    formData.append("selectedType", selectedType);
    
        axios
          .post(`${baseUrl}/admin/faqs/uploadfaqs`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
           .then((response) => {
                  console.log(response.data);
                setAddUploadLoading(false);
                viewAllUploadedFaqs();
                  resetForm();

                Swal.fire({
                  icon : 'success', 
                  title : 'Congrats', 
                  text : 'Faqs created and publised successfully',
                  confirmButtonText : 'Cool'
                })
                })
                .catch((err) => {
                  console.log(err);
                  setAddUploadLoading(false);
                });
      };
        // ---------------- FETCH Faqs ----------------
        const viewAllUploadedFaqs = () => {
          axios
            .get(`${baseUrl}/admin/faqs/viewAllUploadedFaqs`)
            .then((response) => setfaqs(response.data.faqs))
            .catch((error) => console.log(error));
        };
          const updateFaqs= () => {
     const formData = new FormData();
      formData.append("id", idToUpdateDeletefaqs);
      formData.append("question", question);
      formData.append("answer", answer);
      formData.append("selectedType", selectedType);
       axios
            .post(`${baseUrl}/admin/faqs/updateFaqs`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {
              viewAllUploadedFaqs();
              resetForm();
              setAddUploadLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setAddUploadLoading(false);
            });
    
          };
             const deleteFaqs = (idToDelete) => {
                const formData = new FormData();
                formData.append("id", idToDelete);
                axios
                  .post(`${baseUrl}/admin/faqs/deleteFaqs`, formData)
                   .then(() => {
                  viewAllUploadedFaqs();
                  setAddUploadLoading(false);
                })
                .catch((err) => {
                  console.log(err);
                  setAddUploadLoading(false);
                });
              };
            // ---------------- RESET FORM ----------------
const resetForm = () => {
  setQuestion("");
  setAnswer("");
 setSelectedType("Customer");
  setBtnLabel("Save");
  setIdToUpdateDeletefaqs("");
};
   useEffect(() => {
    viewAllUploadedFaqs();
  }, []);




  return (
    <AdminMasterLayout>

      <Container className="faq-container">

        <div className="faq-card">

          <div className="faq-card-header">
            <h4>Upload FAQ</h4>
            <p>Add questions and answers to your FAQ collection</p>
          </div>

          <div className="faq-card-body">

            {showSuccess && (
              <div className="alert alert-success d-flex justify-content-between align-items-center">
                <span>
                  {editId ? "FAQ updated successfully!" : "FAQ added successfully!"}
                </span>

                <button
                  className="btn-close"
                  onClick={() => setShowSuccess(false)}
                ></button>
              </div>
            )}
              {/* Error Message */}
            {errorMessage && (
              <div className="buyer-error-message">{errorMessage}</div>
            )}

            {/* Question */}
            <div className="mb-3">
              <label className="form-label">Question</label>

              <input
                type="text"
                className="form-control"
                placeholder="Enter your question..."
                value={question}
                onChange={(e) => {
    setQuestion(e.target.value);
    setErrorMessage(
      regTpChecker("faqQuestion", e.target.value)
    );
  }}
              
              />
            </div>

            {/* Answer */}
            <div className="mb-3">
              <label className="form-label">Answer</label>

              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter your answer..."
                value={answer}
                 onChange={(e) => {
    setAnswer(e.target.value);
    setErrorMessage(
      regTpChecker("faqAnswer", e.target.value)
    );
  }}
             
              />
            </div>

            {/* Dropdown */}
            <div className="mb-4">
              <label className="form-label">Select User Type</label>

              <select
                className="form-select"
                value={selectedType}
                 onChange={(e) => {
    setSelectedType(e.target.value);
    setErrorMessage(
      regTpChecker("faqType", e.target.value)
    );
  }}
              >
                <option value="Customer">Customer</option>
                <option value="Seller">Seller</option>
              </select>
            </div>

            {/* Button */}
          {/* HEADING */}
<h4>
  {btnLabel === "Save"
    ? "Create New FAQ"
    : "Update FAQ"}
</h4>

{/* BUTTON + SPINNER */}
<div className="mt-3">

  {addUploadLoading ? (

    <div className="text-center">
      <div
        className="spinner-border text-primary"
        role="status"
      >
        <span className="visually-hidden">
          Loading...
        </span>
      </div>
    </div>

  ) : (

    btnLabel === "Save" ? (

     <Button
  disabled={
    addUploadLoading ||
    !question.trim() ||
    !answer.trim() ||
    !selectedType ||
    !!errorMessage
  }
  onClick={() => {
    if (
      !question.trim() ||
      !answer.trim() ||
      !selectedType ||
      errorMessage
    ) {
      return;
    }

    setAddUploadLoading(true);

    if (btnLabel === "Save") {
      uploadfaqs();
    } else {
      updateFaqs();
    }
  }}
>
  {btnLabel === "Save" ? "Save FAQ" : "Update FAQ"}
</Button>
    ) : (

      <button
        type="button"
        className="btn faq-submit-btn"
        onClick={() => {
          setAddUploadLoading(true);
          updateFaqs();
        }}
      >
        Update FAQ
      </button>

    )

  )}

</div>

            {/* TABLE */}
            {faqs.length > 0 && (
              <div className="faq-table-wrapper">

                <div className="faq-table-header">
                  <h5>Uploaded FAQs</h5>

                  <span className="faqs-count">
                    {faqs.length} faqss
                  </span>
                </div>

                <div className="table-responsive">

                  <table className="table faq-table align-middle">

                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Selected Type</th>
                        <th>Question</th>
                        <th>Answer</th>
                        <th width="170">Actions</th>
                      </tr>
                    </thead>

                    <tbody>

                      {faqs.map((faqs, index) => (

                        <tr key={faqs.id}>

                          <td>{index + 1}</td>

                          <td>
                            <span
                              className={`faq-badge ${
                                faqs.selectedType === "Seller"
                                  ? "seller-badge"
                                  : "customer-badge"
                              }`}
                            >
                              {faqs.selectedType}
                            </span>
                          </td>

                          <td className="faqs-question">
                            {faqs.question}
                          </td>

                          <td className="faqs-answer">
                            {faqs.answer}
                          </td>

                          <td>

                            <div className="d-flex gap-2">
                              <Button
  className="btn btn-sm faq-edit-btn"
  disabled={loadingEditId === faqs.id}
  onClick={() => {

    setLoadingEditId(faqs.id);

    setIdToUpdateDeletefaqs(faqs.id);

    setQuestion(faqs.question);
    setAnswer(faqs.answer);
    setSelectedType(faqs.selectedType);

    setBtnLabel("Update");

    setTimeout(() => {
      setLoadingEditId(null);
    }, 500);

  }}
>
  {loadingEditId === faqs.id ? (
    <Spinner animation="border" size="sm" />
  ) : (
    "Edit"
  )}
</Button>
                              
                              <Button
  className="btn btn-sm faq-delete-btn"
  disabled={loadingDeleteId === faqs.id}
  onClick={() => {

    setLoadingDeleteId(faqs.id);

    deleteFaqs(faqs.id);

    setTimeout(() => {
      setLoadingDeleteId(null);
    }, 500);

  }}
>
  {loadingDeleteId === faqs.id ? (
    <Spinner animation="border" size="sm" />
  ) : (
    "Delete"
  )}
</Button>
                              

                            </div>

                          </td>

                        </tr>

                      ))}

                    </tbody>

                  </table>

                </div>

              </div>
            )}

          </div>

        </div>

      </Container>

    </AdminMasterLayout>
  );
};

export default FAQsInAdmin;